<template>
	<div class="introduce">
		<p>
			Now you can download our data of common serum proteins or common serum proteins which partially overlap with the Cancer Serum Atlas: 
			<a href="/static/other/zip/CommonSerumProtein.zip"><span class="cancer-link">common serum protein</span></a>,
			<a href="/static/other/zip/CancersecretedProtein.zip"><span class="cancer-link">cancer-secreted protein</span></a>,
			<br />
			<br />
		</p>

		<mainPic />
	</div>
</template>

<script>
	import axios from "axios"
	import mainPic from '../components/MainPic.vue'

	export default {
		components: {
			'mainPic': mainPic
		},
		methods: {
			download(illness) {
				axios
					.get("/otherDownload.do", {
						responseType: 'blob',
						params: {
							illness: illness
						}
					})
					.then(response => {
						var link = document.createElement("a")
						link.href = window.URL.createObjectURL(new Blob([response.data]))
						link.setAttribute("download", illness + ".zip")
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
					})
					.catch(err => {
						console.log(err)
					})
			}
		}
	}
</script>

<style>
</style>
